import React from 'react';
import colors from 'assets/styleguide/colors';
import Button from 'components/map/Button';
import Icon from 'components/shared/Icon';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
const renderConnectors = (c) => {
    const details = Object.values(c);
    if (details) {
        return details.map((connector, index) => (React.createElement("div", { className: "connector", key: `${connector.power}${connector.name}` },
            index === 0 && React.createElement("div", { className: "name" }, connector.name),
            React.createElement("div", { className: "details" },
                React.createElement("span", { className: "total" }, connector.total),
                React.createElement("span", { className: "x" }, "x"),
                React.createElement("span", { className: "power" },
                    connector.power,
                    " kW")))));
    }
};
export default function StationDetailsModal(props) {
    const { location, onClose } = props;
    const connectorsCcs = location.connectors.IEC_62196_T2_COMBO;
    const connectorsChademo = location.connectors.CHADEMO;
    const connectorsAc = location.connectors.IEC_62196_T2;
    const sendDataToGTM = useGTMDispatch();
    return (React.createElement("div", { className: "inner" },
        React.createElement("div", { className: "header" },
            React.createElement("div", { className: "name" }, location === null || location === void 0 ? void 0 : location.name),
            React.createElement("a", { className: "close", onClick: onClose },
                React.createElement(Icon, { size: 16, icon: "close", color: colors.milkybrown }))),
        React.createElement("div", { className: "connectors" },
            React.createElement(React.Fragment, null, connectorsCcs && renderConnectors(connectorsCcs)),
            React.createElement(React.Fragment, null, connectorsChademo && renderConnectors(connectorsChademo)),
            React.createElement(React.Fragment, null, connectorsAc && renderConnectors(connectorsAc))),
        React.createElement(Button, { onClick: () => sendDataToGTM({
                dataLayerName: 'Website',
                data: { event: 'navigationLocations', value: location === null || location === void 0 ? void 0 : location.name },
            }), href: `https://www.google.com/maps/dir/?api=1&destination=${location.coordinates.latitude},${location.coordinates.longitude}&travelmode=driving`, target: "_blank", style: { width: '100%', textAlign: 'center' } },
            React.createElement(Icon, { icon: "directions", size: 20, color: colors.darkText }),
            "Navigate")));
}
